// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nQLrQ3wImw_7WJTA {
  margin-left: 12px;
  background-color: #4d87be;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  width: fit-content;
  padding: 6px 15px;
  height: fit-content;
  border-radius: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pQ_AdBjf2g0nCXBj {
  max-width: 1310px;
  margin: 0 auto;
  padding-bottom: 96px;
}

.pQ_AdBjf2g0nCXBj h2 {
  color: #303030;
  font-size: 30px;
  font-weight: 600;
  margin: 0;
}

.npVRs6HCZMHHL9fC {
  margin-top: 20px;
  width: 450px;
  height: 58px;
  padding: 12px 10px;
  border-radius: 16px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
  background: #ffffff;
}

.U71A4p2aEdbppflB {
  margin: 29px 0 30px 0;
}

.pQ_AdBjf2g0nCXBj .p-datatable-table {
  border-radius: 16px;
  overflow: hidden;
}

.pQ_AdBjf2g0nCXBj .p-datatable-thead th {
  background-color: #f2e1bc;
  border: 1px solid #f3f5f7;
  padding: 18px 30px;
}

.pQ_AdBjf2g0nCXBj .p-datatable-thead th:first-child > div {
  display: flex;
  justify-content: flex-start;
}

.pQ_AdBjf2g0nCXBj .p-datatable-thead th > div {
  display: flex;
  justify-content: center;
  color: #303030;
  font-size: 18px;
}

.pQ_AdBjf2g0nCXBj .p-datatable-tbody td {
  border: 1px solid #f3f5f7;
  padding: 9px 8px;
}

.pQ_AdBjf2g0nCXBj .p-datatable-tbody tr td:first-child {
  text-align: left;
}

.pQ_AdBjf2g0nCXBj .p-datatable-tbody tr td {
  text-align: center;
}

.pQ_AdBjf2g0nCXBj .p-datatable-tbody td:hover .ys6R5EumVzAMTv3P {
  background-color: #e1e7ed;
}

.ys6R5EumVzAMTv3P {
  padding: 28px 22px;
  border-radius: 6px;
}

.YNf9oAdV1HIwNZiS {
  width: 114px;
  height: 67px;
  border-radius: 6px;
}

.pQ_AdBjf2g0nCXBj .p-datatable-tbody td:hover .YNf9oAdV1HIwNZiS {
  background-color: #e1e7ed;
}

.TORZEhdSAAAIbOed {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.TGayop_fIT4tiZbm {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ON8dcpA9HOsyFR9E {
  display: flex;
  flex-direction: column;
}

.jv8d4zvf1MwOs3Lr {
  font-weight: 500;
  color: #303030;
  font-size: 14px;
}

.jaVkRSdMx8s2dOb0 {
  display: flex;
  gap: 12px;
}

.gxdAZCKwgHEYdQjL {
  color: #1976d2;
  background: none;
  border: none;
}

.gxdAZCKwgHEYdQjL i::before {
  font-size: 26px;
}

.U71A4p2aEdbppflB {
  margin: 29px 0 30px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
}

.GIy4zc8S0CsRB5jR {
  display: flex;
  margin-top: 15px;
}

.ccUuZVL5Un4AwExo {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

@media screen and (max-width: 510px) {
  .U71A4p2aEdbppflB {
    display: flex;
    flex-direction: column-reverse;
  }

  .U71A4p2aEdbppflB h2 {
    font-size: 20px;
    font-weight: 700;
  }

  .GIy4zc8S0CsRB5jR {
    grid-area: title;
    margin: 0;
  }

  .nQLrQ3wImw_7WJTA {
    display: none;
  }

  .OeElIxELnEcAj5KU {
    padding: 0;
    margin-top: 12px;
    margin-bottom: 25px;
    width: 100%;
    grid-area: btn;
  }

  .OeElIxELnEcAj5KU span {
    display: none;
  }

  .OeElIxELnEcAj5KU i {
    font-size: 12px;
    background-color: #f2e1bc;
    padding: 10px;
    border-radius: 6px;
    margin-left: 0;
    width: 100%;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tnfivNgCOZE8RHjN,
  .weQbXRuA5Y4ekPct {
    width: 350px !important;
  }

  .weQbXRuA5Y4ekPct .field label {
    font-size: 14px !important;
  }

  .tnfivNgCOZE8RHjN .p-dialog-title,
  .weQbXRuA5Y4ekPct .p-dialog-title {
    font-size: 20px !important;
    font-weight: 700 !important;
  }

  .tnfivNgCOZE8RHjN .w4uuHlSpttoRHdxP {
    font-size: 16px;
  }

  .mCN9HdrrElYBa49I {
    font-size: 14px;
    padding: 14px 20px;
    background-color: #ffffff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
      0 2px 6px rgba(0, 0, 0, 0.12);
  }

  .WX0FEUrNRkNey58G {
    font-size: 14px;
  }

  .QbbS84sG41MGMlIh {
    padding: 14px 0;
    font-size: 16px;
  }

  .PiCUMDN_r0wGaPdW {
    border-radius: 8px;
    padding: 14px 16px;
    font-size: 16px;
  }

  .sbLB5piiM_kwWokX {
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 16px;
  }

  .smuo0T9EHfU_ITqx .p-dropdown-label {
    font-size: 14px;
  }

  .npVRs6HCZMHHL9fC {
    width: 100%;
    height: 44px;
    margin: 0;
    padding: 5px 10px;
    border-radius: 16px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
    background: #ffffff;
    grid-area: dropdown;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Admin/components/Notifications.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gDAAgD;EAChD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB;mCAC+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,4CAA4C;IAC5C,mBAAmB;IACnB,mBAAmB;EACrB;AACF","sourcesContent":[".organizationLabel {\r\n  margin-left: 12px;\r\n  background-color: #4d87be;\r\n  color: #fff;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  width: fit-content;\r\n  padding: 6px 15px;\r\n  height: fit-content;\r\n  border-radius: 200px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.pageWrapper {\r\n  max-width: 1310px;\r\n  margin: 0 auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.pageWrapper h2 {\r\n  color: #303030;\r\n  font-size: 30px;\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n.dropdown {\r\n  margin-top: 20px;\r\n  width: 450px;\r\n  height: 58px;\r\n  padding: 12px 10px;\r\n  border-radius: 16px;\r\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);\r\n  background: #ffffff;\r\n}\r\n\r\n.header {\r\n  margin: 29px 0 30px 0;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-table) {\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th) {\r\n  background-color: #f2e1bc;\r\n  border: 1px solid #f3f5f7;\r\n  padding: 18px 30px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th:first-child > div) {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th > div) {\r\n  display: flex;\r\n  justify-content: center;\r\n  color: #303030;\r\n  font-size: 18px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td) {\r\n  border: 1px solid #f3f5f7;\r\n  padding: 9px 8px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td:first-child) {\r\n  text-align: left;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td) {\r\n  text-align: center;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td:hover) .cellInsider {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.cellInsider {\r\n  padding: 28px 22px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.activeBtn {\r\n  width: 114px;\r\n  height: 67px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td:hover) .activeBtn {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.cardList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.cardItem {\r\n  background: #ffffff;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.cardInfo {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.name {\r\n  font-weight: 500;\r\n  color: #303030;\r\n  font-size: 14px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.cardEditBtn {\r\n  color: #1976d2;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.cardEditBtn i::before {\r\n  font-size: 26px;\r\n}\r\n\r\n.header {\r\n  margin: 29px 0 30px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 18px;\r\n}\r\n\r\n.headerTitle {\r\n  display: flex;\r\n  margin-top: 15px;\r\n}\r\n\r\n.headerContent {\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n@media screen and (max-width: 510px) {\r\n  .header {\r\n    display: flex;\r\n    flex-direction: column-reverse;\r\n  }\r\n\r\n  .header h2 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .headerTitle {\r\n    grid-area: title;\r\n    margin: 0;\r\n  }\r\n\r\n  .organizationLabel {\r\n    display: none;\r\n  }\r\n\r\n  .createBtn {\r\n    padding: 0;\r\n    margin-top: 12px;\r\n    margin-bottom: 25px;\r\n    width: 100%;\r\n    grid-area: btn;\r\n  }\r\n\r\n  .createBtn span {\r\n    display: none;\r\n  }\r\n\r\n  .createBtn i {\r\n    font-size: 12px;\r\n    background-color: #f2e1bc;\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    margin-left: 0;\r\n    width: 100%;\r\n    height: 26px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .deleteModal,\r\n  .userModal {\r\n    width: 350px !important;\r\n  }\r\n\r\n  .userModal :global(.field) label {\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .deleteModal :global(.p-dialog-title),\r\n  .userModal :global(.p-dialog-title) {\r\n    font-size: 20px !important;\r\n    font-weight: 700 !important;\r\n  }\r\n\r\n  .deleteModal .text {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .input {\r\n    font-size: 14px;\r\n    padding: 14px 20px;\r\n    background-color: #ffffff;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n      0 2px 6px rgba(0, 0, 0, 0.12);\r\n  }\r\n\r\n  .phonePrefix {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .saveBtn {\r\n    padding: 14px 0;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .deleteDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 14px 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cancelDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dropDownWrapper :global(.p-dropdown-label) {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .dropdown {\r\n    width: 100%;\r\n    height: 44px;\r\n    margin: 0;\r\n    padding: 5px 10px;\r\n    border-radius: 16px;\r\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);\r\n    background: #ffffff;\r\n    grid-area: dropdown;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var organizationLabel = `nQLrQ3wImw_7WJTA`;
export var pageWrapper = `pQ_AdBjf2g0nCXBj`;
export var dropdown = `npVRs6HCZMHHL9fC`;
export var header = `U71A4p2aEdbppflB`;
export var cellInsider = `ys6R5EumVzAMTv3P`;
export var activeBtn = `YNf9oAdV1HIwNZiS`;
export var cardList = `TORZEhdSAAAIbOed`;
export var cardItem = `TGayop_fIT4tiZbm`;
export var cardInfo = `ON8dcpA9HOsyFR9E`;
export var name = `jv8d4zvf1MwOs3Lr`;
export var actions = `jaVkRSdMx8s2dOb0`;
export var cardEditBtn = `gxdAZCKwgHEYdQjL`;
export var headerTitle = `GIy4zc8S0CsRB5jR`;
export var headerContent = `ccUuZVL5Un4AwExo`;
export var createBtn = `OeElIxELnEcAj5KU`;
export var deleteModal = `tnfivNgCOZE8RHjN`;
export var userModal = `weQbXRuA5Y4ekPct`;
export var text = `w4uuHlSpttoRHdxP`;
export var input = `mCN9HdrrElYBa49I`;
export var phonePrefix = `WX0FEUrNRkNey58G`;
export var saveBtn = `QbbS84sG41MGMlIh`;
export var deleteDialogBtn = `PiCUMDN_r0wGaPdW`;
export var cancelDialogBtn = `sbLB5piiM_kwWokX`;
export var dropDownWrapper = `smuo0T9EHfU_ITqx`;
export default ___CSS_LOADER_EXPORT___;
